export const copyStringToClipboard = (str: string): void => {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.classList.add("hidden");
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};
export default copyStringToClipboard;
